// 그래프들을 볼 수 있는 직군별 필터링 "사이드 " 팝업입니다.

import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useEventTracking } from '../../../../../helpers/gtmHelper'
import { useCafJobGraphData, useCafJobId, useCafJobLevelData } from '../../../../../modules/apis/student/lesson'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_ai_analysis } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../../modules/vars'
import { useCafSidePopup } from '../../common/CafSidePopup'
import { CafJobAnalysisBox } from '../../common/JobAnalysis/CafJobAnalysisBox'
import CafJobAnalysisReferralBox from '../../common/JobAnalysis/CafJobAnalysisReferralBox'
import JobFilterSection from '../../common/JobAnalysis/JobFilterSection'
import SidePopupBody from './components/Body'

const DEFAULT_PROPS = {
  hFull: true,
  bgWhite: true,
  maxW: 512,
  noTopSide: true,
  overlayClose: true,
}

const useCafJobAnalysisSidePopup = () => {
  const sidePopup = useCafSidePopup()
  const { t } = useTranslation()

  // TODO: isLoading은 왜 없어도 되고, useEffect 인자 안에 왜 graphData가 있어야 하는가?

  const close = () => {
    sidePopup.close(popupId)
  }

  const popupId = 'JobAnalysis'

  const show = () => {
    sidePopup.show({
      ...DEFAULT_PROPS,
      id: popupId,
      onClose: close,
      body: (
        <SidePopupBody
          headerProps={{
            title: (
              <div className="flex flex-row items-center justify-start text-[20px] font-bold text-black">
                {t(n_ai_analysis.job_seg_level.title)}
              </div>
            ),
            onClose: close,
          }}
        >
          <div className="flex w-full flex-col items-start justify-start">
            <AiJobAnalysisContent />
          </div>
        </SidePopupBody>
      ),
      bgColor: COLORS.WHITE,
    })
  }

  return { show, close }
}

const InstructionMessage = () => {
  const { t } = useTranslation()

  return (
    // TOOD 워딩시트 text-14 text-gray-500
    <div className="Body2-14Md text-gray-500">
      {t(n_ai_analysis.job_seg_level.detail1)}
      <br />
      {t(n_ai_analysis.job_seg_level.detail2)}
    </div>
  )
}

export const AiJobAnalysisContent = (): JSX.Element => {
  const [keyArray, setKeyArray] = useState<string[]>([])
  const { data: jobIdData } = useCafJobId()
  const [selectedJobId, setSelectedJobId] = useState<number>(jobIdData?.job_id)
  const { sendPageViewEvent } = useEventTracking()
  const router = useAppRouter()

  useEffect(() => {
    if (jobIdData) {
      setSelectedJobId(jobIdData.job_id)
    }
  }, [jobIdData])

  const { data: graphData } = useCafJobGraphData(selectedJobId)
  const { data: levelData } = useCafJobLevelData(selectedJobId)

  useEffect(() => {
    setKeyArray(Object.keys(levelData.levels))
  }, [levelData])

  useEffect(() => {
    if (!router) return
    sendPageViewEvent({ page_name: 'ai_analysis_job_segment', object_id: selectedJobId })
  }, [router.asPath])

  return (
    <div className="flex w-full flex-col gap-[12px]">
      <JobFilterSection
        selectedJobId={selectedJobId}
        setSelectedJobId={setSelectedJobId}
        userJobId={jobIdData?.job_id}
      />

      {keyArray.map(
        (item, index) =>
          levelData.levels[item] !== 0 && (
            <CafJobAnalysisBox
              key={'overview' + uuidv4()}
              title={item}
              levelExact={levelData.levels[item]}
              graphData={graphData[item]}
              percentile={levelData.percents[item]}
            />
          )
      )}
      <InstructionMessage />
      <CafJobAnalysisReferralBox page={'overview'} selectedJobId={selectedJobId} />
    </div>
  )
}

export default useCafJobAnalysisSidePopup
